/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateNoteMentionableUsersPathParams,
	CandidateNoteMentionableUsersResponse,
} from '../types/CandidateNoteMentionableUsers'

/**
 * GET /candidates/:candidate/mentionable-users
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::mentionableUsers
 */
export async function candidateNoteMentionableUsers(
	candidate: CandidateNoteMentionableUsersPathParams['candidate'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateNoteMentionableUsersResponse>> {
	return axiosInstance.get(`/candidates/${candidate}/mentionable-users`, config)
}
